import React, { useState, useEffect, useRef } from "react";
import clsx from "clsx";

import { ReactComponent as IconCaret } from "../../assets/svg/caret_up.svg";
import { ReactComponent as IconCheck } from "../../assets/svg/check.svg";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { Option } from "../Dropdown";

import styles from "./DropdownAssessment.module.scss";

type Props = {
  options: Option[];
  defaultValue?: Option;
  className?: string;
  classNameOptions?: string;
  onChange: (value: number, data?: any) => void;
};

export const DropdownAssessment: React.FC<Props> = ({
  options,
  defaultValue,
  className,
  classNameOptions,
  onChange,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [optionSelected, setOptionSelected] = useState<Option>({
    value: -1,
    label: "",
    data: null,
  });

  useEffect(() => {
    if (
      defaultValue === undefined &&
      optionSelected.value === -1 &&
      options.length !== 0
    ) {
      setOptionSelected(options[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, defaultValue]);

  useEffect(() => {
    if (optionSelected.value !== -1) {
      onChange(optionSelected.value, optionSelected.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionSelected.value]);

  useEffect(() => {
    if (defaultValue) {
      setOptionSelected({
        value: defaultValue.value,
        label: defaultValue.label,
        data: defaultValue.data,
      });
    }
  }, [defaultValue]);

  const labelChange = (option: Option) => {
    if (options.length !== 0) return option.label;
    else return "";
  };

  const handleClickOutside = () => setOpen(false);

  useOnClickOutside(ref, handleClickOutside);

  return (
    <div
      ref={ref}
      className={clsx(styles.wrapSelect, className)}
      onClick={() => setOpen(!open)}
    >
      <div className={styles.option}>
        <div className={styles.label}>{labelChange(optionSelected)}</div>
        <IconCaret />
      </div>
      {open && options.length !== 0 && (
        <div className={clsx(styles.options, classNameOptions)}>
          {options.map((item, index) => (
            <div
              className={clsx(
                styles.option,
                item.value === optionSelected.value && styles.active,
              )}
              onClick={() => {
                setOptionSelected(item);
              }}
              key={index}
            >
              <div className={styles.label}>{item.label}</div>
              <IconCheck />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default DropdownAssessment;
